export const ignoreErrors = [
  'Failed to fetch',
  'GraphQL fetch failed',
  'Network error',
  'Load failed',
  'AbortError',
  'Connection is closing',
  'Database deleted by request of the user',
  'The database connection is closing',
  'Installations: Could not process request. Application offline.', // firebase error
  'Remote Config: Error thrown when reading from storage. Original error: The transaction was aborted, so the request cannot be fulfilled', // firebase error
  'Remote Config: Error thrown when opening storage. Original error: The connection was closed', // firebase error
];
